export default "__VITE_ASSET__RuzkZSOk__"